export const setLocalStorageItemHandler = (key, value) => {
  if (!!window) window.localStorage.setItem(key, value);
};

export const getLocalStorageItemHandler = (key) => {
  if (!!window) return JSON.parse(window.localStorage.getItem(key));
};

export const clearLocalStorage = (key) => {
  window.localStorage.clear();
};
